import React from 'react';
import whyDidYouRender from '@welldone-software/why-did-you-render';

// ? USE DEBUG_ENV TO TRACK THE RE-RENDERS.
if (process.env.REACT_APP_ENV_TYPE === 'debug') {
    whyDidYouRender(React, {
        trackAllPureComponents: true
    });
}
